/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export type ContextBinding = 'none' | 'two-way' | 'context-to-model' | 'model-to-context';

export class ContextBindings {
  static readonly NONE: ContextBinding = 'none';
  static readonly TWO_WAY: ContextBinding = 'two-way';
  static readonly CONTEXT_TO_MODEL: ContextBinding = 'context-to-model';
  static readonly MODEL_TO_CONTEXT: ContextBinding = 'model-to-context';
}
